import styled, { css } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { Color, Size } from './types';

export const Container = styled.div<{ color: Color; size: Size }>`
  box-sizing: border-box;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Alert', 'size'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Alert', 'color'))};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Alert'))};
`;
